import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/dist/query';
import Box from '@mui/material/Box';
import { useGetTimeTrackerReportTokenQuery } from '../../app/services/interview';
import ErrorPage from '../error/ErrorPage';
import { GlobalLoading } from '../../common/components/GlobalLoading';
import dayjs from 'dayjs';
import { openTimeTrackerReport } from '../../common/utils/reportUtils';

export default function ViewTimeTrackerReport() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const currentStartDate = dayjs().startOf("month").format("MM/DD/YYYY");
  const currentEndDate = dayjs().endOf("month").format("MM/DD/YYYY");

  const searchOptions = {
    patientId: searchParams.get('patientId') || '',
    fromDate: searchParams.get('fromDate') || currentStartDate,
    toDate: searchParams.get('toDate') || currentEndDate,
    sort: searchParams.get('sort') || 'dateOfService',
    dir: searchParams.get('dir') || 'desc',
  };

  const { data: reportToken, isLoading, error } = useGetTimeTrackerReportTokenQuery(
    searchOptions.patientId
      ? {
        ...searchOptions
      }
      : skipToken
  );

  useEffect(() => {
    if (reportToken) {
      window.location.href = openTimeTrackerReport(reportToken.token);
    }
  }, [reportToken]);

  if (error) {
    return <ErrorPage statusCode={(error as FetchBaseQueryError).status} />;
  }

  return (
    <Box>
      {isLoading && (
        <GlobalLoading
          appBarHeight={0}
          loadingText={t('timeTracker.report.generatingReport')}
        />
      )}
    </Box>
  );
}
